import axios from 'axios'
import route from '../src/router/index.js'
import {
    Message,
    MessageBox,
} from 'element-ui'


let apiUrl='https://manage.woshuoxia.com/';//(生产)
//let apiUrl='http://demo.woshuoxia.com/woshuoxia/public/';//(测试)
//let apiUrl='http://www.woshuoxiaTest.com/';//(本地)
let pageNum=15;
export default{

    /**
     * get方式请求数据
     * @param url
     * @param data
     * @param callback
     */
    request:function(url,data,callback,method){
        let _this=this;
        method = method || 'get';
        data['user-token']=localStorage.getItem('_token');
        if(method == 'post'){
            var params = new URLSearchParams();
            for(let key  in data){
                params.append(key, data[key]);
            }
            axios({//格式a
                method:method,
                url:apiUrl+url,
                headers:{
                    'Content-Type': "application/x-www-form-urlencoded"
                },
                data: params,//参数
            }).then(function(resp){
                let data = resp.data;

                //系统维护
                if(data.status == 470){
                    route.push({
                        path:'/view470'
                    });//系统升级
                    return;
                }

                //用户信息失效
                if(data.status == 440 && localStorage.getItem('user_get')){
                    localStorage.setItem('user_get',false);
                    if(document.getElementsByClassName('el-message').length < 1){
                        Message({
                            message: data.message,
                            type: 'warning',
                            duration: 1500,
                            center: true,
                            onClose:function (res) {
                                _this.loginOut();
                            }
                        });
                    }

                    return;
                }

                if(data.status ==400){
                    if(document.getElementsByClassName('el-message').length < 1){
                        Message({
                            message: data.message,
                            type: 'warning',
                            duration: 1000,
                            center: true
                        });
                    }
                    return callback(data);
                }
                localStorage.setItem('user_get',true);
                return callback(data);
            }).catch(resp => {
                if(document.getElementsByClassName('el-message').length < 1) {
                    Message({
                        message: '网络请求失败，请稍后重试',
                        type: 'error',
                        duration: 1000,
                        center: true
                    });
                }
            });
        }else {
            axios({//格式a
                method:method,
                url:apiUrl+url,
                headers:{
                    'Content-Type': "application/x-www-form-urlencoded"
                },
                params: data,//参数
            }).then(function(resp){
                let data = resp.data;

                //系统维护
                if(data.status == 470){
                    route.push({
                        path:'/view470'
                    });//系统升级
                    return;
                }

                //用户信息失效
                if(data.status == 440 && localStorage.getItem('user_get')){
                    localStorage.setItem('user_get',false);
                    if(document.getElementsByClassName('el-message').length < 1){
                        Message({
                            message: data.message,
                            type: 'warning',
                            duration: 1500,
                            center: true,
                            onClose:function (res) {
                                _this.loginOut();
                            }
                        });
                    }

                    return;
                }

                if(data.status ==400){
                    if(document.getElementsByClassName('el-message').length < 1){
                        Message({
                            message: data.message,
                            type: 'warning',
                            duration: 1000,
                            center: true
                        });
                    }
                    return callback(data);
                }
                localStorage.setItem('user_get',true);
                return callback(data);
            }).catch(resp => {
                console.log(resp);
                if(document.getElementsByClassName('el-message').length < 1) {
                    Message({
                        message: '网络请求失败，请稍后重试',
                        type: 'error',
                        duration: 1000,
                        center: true
                    });
                }
                console.log('请求失败：'+resp.status+','+resp.statusText);
            });
        }
    },
    /**
     * 上传文件
     * @param data
     */
    requestUp:function(data,callback){
        let _this=this;
        axios({//格式a
            method:'post',
            url:_this.uploadUrl(),
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: data,//参数
        }).then(function(resp){
            let data = resp.data;
            if(data.status != 1){
                if(document.getElementsByClassName('el-message').length < 1) {
                    Message({
                        message: '请选择图片',
                        type: 'error',
                        duration: 2500,
                        center: true
                    });
                }
                return;
            }
            return callback(data);
        }).catch(resp => {
            console.log(resp);
            if(document.getElementsByClassName('el-message').length < 1) {
                Message({
                    message: '网络请求失败，请稍后重试',
                    type: 'error',
                    duration: 2500,
                    center: true
                });
            }
            console.log('请求失败：'+resp.status+','+resp.statusText);
        });
    },
    //是否登陆
    isLogin:function(){
        if(localStorage.getItem('_token')){
            return true;
        }else {
            return false;
        }
    },
    //退出登陆需要确认
    loginOutSure(){
        let _this=this;
        MessageBox.confirm(
            '是否退出该账户?',
            '确定登出', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }
        ).then(() => {
            Message({
                message: '登出成功',
                type: 'success',
                duration: 1500,
                center: true,
                onClose:function (res) {
                    _this.loginOut();
                }
            });
        }).catch(() => {
            console.log('取消登出');
        });
    },
    //登陆确认
    onLoginSure(){
        let _this=this;
        MessageBox.confirm(
            '当前操作需要登录/注册后才可体验，立即前往登录/注册！',
            '前往登录/注册', {
                confirmButtonText: '立即前往',
                cancelButtonText: '在等等',
                type: 'warning'
            }
        ).then(() => {
            _this.loginOut();
        }).catch(() => {
            console.log('取消登出');
        });
    },
    //退出登陆
    loginOut:function () {
        localStorage.removeItem('_token');//清除缓存
        localStorage.removeItem('userInfo');//清除缓存
        route.push('/')
    },
    //分页条数
    pageNum:function () {
        return pageNum;
    },
    //上传文件路径
    uploadUrl:function () {
        if(window.location.host=='www.woshuoxia.com'){
            apiUrl='http://'+window.location.host+'/public/';
        }
        return apiUrl+'file/upload-img';
    },

    smsSignKey:function(){
        return 'woshuoxia';
    },

    //打开远程链接
    openUrl:function (url) {
        window.open(url)
    },

    /**
     * 提示信息
     * @param message
     * @param type
     */
    vMessage:function (message,type) {
        type = type || 'success';
        if(document.getElementsByClassName('el-message').length < 1){
            Message({
                message: message,
                type: type,
                duration: 1000,
                center: true
            });
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./commonFunction/common.js
// module id = null
// module chunks = 